import { jsx as t } from "react/jsx-runtime";
import "../../base-nYmjnkiN.js";
import "react";
import { cssX as m } from "../../core/utils/css.js";
import "../../index-C7ezJk5b.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
const l = ({
  testId: o,
  children: r
}) => /* @__PURE__ */ t("div", { className: m("Header__logo"), "data-testid": o, children: r });
export {
  l as default
};
